import type { StandingOrders } from './StandingOrders';

export const RS: Partial<StandingOrders> = {
    createSweepOrders: false,
    standingOrderIntervals: ['DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'],
    fetchReceiver: true,
    daysFromTodayOutsideRange: 1,
    executionModes: ['UNTIL_CANCELLATION', 'UNTIL_DATE'],
    executionModesSweep: [
        'UNTIL_CANCELLATION',
        'UNTIL_DATE',
        'AFTER_MAX_ITERATION_EXCEEDED',
        'AFTER_MAX_AMOUNT_EXCEEDED',
    ],
    disableExecutionIntervalSelectOnEdit: true,
};
